import React from 'react'
import { FormControl } from 'react-bootstrap'

export function parseDurationInput (value) {
  if (value === '' || value === null || value === undefined) return null

  const trimmed = value.toString().trim().replace(',', '.')
  if (!trimmed) return null

  if (trimmed.includes(':')) {
    const [hoursPart, minutesPart] = trimmed.split(':')
    const hours = parseInt(hoursPart, 10) || 0
    const minutes = parseInt(minutesPart, 10) || 0
    if (minutes < 0 || minutes >= 60) return null
    return hours + (minutes / 60)
  }

  const num = parseFloat(trimmed)
  return Number.isNaN(num) ? null : num
}

export function formatDurationDisplay (value) {
  if (value === '' || value === null || value === undefined) return ''

  const num = Number(value)
  if (Number.isNaN(num)) return ''

  const hours = Math.floor(num)
  const minutes = Math.round((num - hours) * 60)

  if (minutes === 0) return String(hours)
  return `${hours}:${String(minutes).padStart(2, '0')}`
}

function addMinutes (currentValue, minutesToAdd) {
  const current = parseDurationInput(currentValue) || 0
  return formatDurationDisplay(current + (minutesToAdd / 60))
}

const QUICK_ADD = [
  { label: '+15m', minutes: 15 },
  { label: '+30m', minutes: 30 },
  { label: '+45m', minutes: 45 },
  { label: '+1h', minutes: 60 }
]

function DurationInput ({ value, onChange, placeholder = 'es. 2:30 o 2.5', onBlur }) {
  const parsed = parseDurationInput(value)
  const hint = parsed !== null ? `= ${parsed.toFixed(2).replace(/\.?0+$/, '')} ore` : null

  return (
    <div className='duration-input'>
      <FormControl
        value={value}
        placeholder={placeholder}
        onChange={e => onChange(e.target.value)}
        onBlur={onBlur}
        inputMode='decimal'
      />
      <div className='duration-input-actions'>
        {QUICK_ADD.map(item => (
          <button
            key={item.label}
            type='button'
            className='duration-input-chip'
            onClick={() => onChange(addMinutes(value, item.minutes))}
          >
            {item.label}
          </button>
        ))}
      </div>
      {hint && <span className='duration-input-hint'>{hint}</span>}
    </div>
  )
}

export default DurationInput
